(() => {
  const init = (root = document) => {
    root.querySelectorAll('.lp-buy-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('button');
        if (button) { button.setAttribute('aria-busy', 'true'); setTimeout(() => { button.removeAttribute('aria-busy'); }, 8000); }
      });
    });
    if (window.Trustpilot) root.querySelectorAll('.trustpilot-widget').forEach(widget => window.Trustpilot.loadFromElement(widget, true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

